import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'sticky z-60 transition-transform duration-300 ease-in-out max-md:-bottom-[24px] md:-bottom-[64px] md:-mr-[52px] md:-ml-[52px]',
    content:
      'relative -right-3 -left-3 flex w-[calc(100%+24px)] justify-between bg-white p-[10px] shadow-[0px_-4px_12px_rgba(0,0,0,0.07)] md:pr-[64px] md:pl-[64px]',
    button: 'max-md:w-[180px] md:w-[300px]'
  },
  variants: {
    visible: {
      true: {
        base: 'translate-y-0'
      },
      false: {
        base: 'hidden translate-y-full'
      }
    }
  },
  defaultVariants: {
    visible: true
  }
});
